import React from 'react';
import Recent from './component';

export default React.memo(Recent);
